import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca1ae1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-list" }

import { onMounted, reactive } from 'vue';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import teacherIcon from '@/assets/icons/emojis/teacher.png';
import calendarIcon from '@/assets/icons/emojis/calendar.png';
import getAnnouncementsSubpage from './api-methods';
import moment from 'moment';
import { IAnnouncementsSubPageResponseModel } from './announcements-subpage.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementsSubpage',
  setup(__props) {

const state = reactive<{ data: IAnnouncementsSubPageResponseModel }>({
    data: {} as IAnnouncementsSubPageResponseModel,
});

onMounted(() => {
    const version = localStorage.getItem('announcementsVersion');
    const announcements = localStorage.getItem('announcements');
    announcements && version
        ? getAnnouncementsSubpage(version, state)
        : getAnnouncementsSubpage(null, state);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.announcements, (announcement) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        props: {
                content: announcement.notificationText,
                type: 'outlined',
                dataTags: [
                    {
                        title:
                            'Отправитель: ' +
                            announcement.notificationAuthorSurenameAndInitials,
                        iconCompleteUrl: _unref(teacherIcon),
                        color: '',
                    },
                    {
                        title:
                            'Дата отправления: ' +
                            _unref(moment)(announcement.date).format('DD.MM.YYYY'),
                        iconCompleteUrl: _unref(calendarIcon),
                        color: '',
                    },
                ],
            },
        key: announcement.notificationId
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})